import { css } from '@emotion/react'
import { colors, font } from 'plume-ui'
import {
  isDomesticCompanyData,
  isResearchContinue as isResearchContinued,
} from '@/lib/company'
import { LineClampText } from '../../../atoms/LineClampText'
import { CompanyData, OverseasCompanyData } from '../../../../types/api'
import { A } from '../../../atoms/A'
import React, { useState, useRef, useEffect } from 'react'
import { IGNORED_BY_WOVN_CLASS_NAME } from '@/lib/wovn'
import { FormattedDate } from '../../../atoms/FormattedDate'

type Props = { company: CompanyData | OverseasCompanyData }

export const Description: React.FC<Props> = ({ company }) => {
  const [isInitialized, setIsInitailized] = useState(false)
  const [isShowAll, setIsShowAll] = useState(false)
  const textEl = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    setIsShowAll(false)
  }, [company])

  useEffect(() => {
    if (!textEl || !textEl.current) {
      return
    }
    setIsInitailized(true)
    if (!isOverflown(textEl.current)) {
      setIsShowAll(true)
    }
  }, [textEl])

  const handleClickReadMore = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    setIsShowAll(true)
  }

  const showReadMore = isInitialized && !isShowAll

  return (
    <div
      className="description"
      css={css`
        margin-top: 20px;
      `}
      data-test-id="description"
    >
      <div>
        <span
          css={css`
            font-weight: ${font.weight.bold};
            font-size: 13px;
            color: ${colors.black10};
          `}
        >
          事業内容
        </span>
        {isDomesticCompanyData(company) && isResearchContinued(company) && (
          <span
            css={css`
              font-size: 12px;
              padding-left: 10px;
              color: ${colors.textLight};
            `}
          >
            <span
              className={IGNORED_BY_WOVN_CLASS_NAME}
              data-test-id="updated-at"
            >
              <FormattedDate>{company.descriptionUpdatedAt}</FormattedDate>
            </span>
            {` 更新`}
          </span>
        )}
      </div>
      <div
        css={css`
          display: flex;
          align-items: flex-end;
          grid-gap: 12px;
          padding-bottom: 18px;
          margin-top: 5px;
          white-space: pre-wrap;
          line-height: 1.5;
          font-size: 14px;
          line-height: 1.4;
        `}
      >
        <LineClampText
          justify
          lineNumber={2}
          showAll={isShowAll}
          lineClampRef={textEl}
          className="text"
        >
          {company.description}
        </LineClampText>
        {showReadMore && (
          <A
            className="view-all"
            onClick={handleClickReadMore}
            css={css`
              flex-shrink: 0;
              font-size: 14px;
            `}
          >
            すべて見る
          </A>
        )}
      </div>
    </div>
  )
}

const isOverflown = (elm: HTMLElement) => {
  return (
    elm.scrollHeight > elm.clientHeight || elm.scrollWidth > elm.clientWidth
  )
}
